<script>
import { Bar, mixins } from 'vue-chartjs';
import chartMixins from '../../../mixins/charts';

const { reactiveProp } = mixins;

export default Bar.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    this.addPlugin(chartMixins.plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  },
});
</script>



// WEBPACK FOOTER //
// AnalyticsBarChart.vue?1cabf760